import React, { useState } from 'react';
import { 
  Plus, 
  Search, 
  Edit, 
  Trash2, 
  Users,
  UserPlus,
  Eye
} from 'lucide-react';
import GroupModal from '../components/GroupModal';

const Groups = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  // Données simulées
  const [groups, setGroups] = useState([
    {
      id: 1,
      nom: 'Clients VIP',
      description: 'Clients avec un chiffre d\'affaires élevé',
      contact_count: 45,
      date_creation: '2024-01-15'
    },
    {
      id: 2,
      nom: 'Prospects',
      description: 'Contacts potentiels à contacter',
      contact_count: 128,
      date_creation: '2024-02-20'
    },
    {
      id: 3,
      nom: 'Anciens clients',
      description: 'Clients qui n\'ont pas acheté récemment',
      contact_count: 67,
      date_creation: '2024-03-10'
    },
  ]);

  const filteredGroups = groups.filter(group =>
    group.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
    group.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleEdit = (group) => {
    setEditingGroup(group);
    setIsModalOpen(true);
  };

  const handleDelete = (groupId) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce groupe ?')) {
      setGroups(groups.filter(g => g.id !== groupId));
    }
  };

  const handleSaveGroup = (groupData) => {
    if (editingGroup) {
      setGroups(groups.map(g => 
        g.id === editingGroup.id ? { ...g, ...groupData } : g
      ));
    } else {
      const newGroup = {
        ...groupData,
        id: Date.now(),
        contact_count: 0,
        date_creation: new Date().toISOString().split('T')[0]
      };
      setGroups([...groups, newGroup]);
    }
    setIsModalOpen(false);
    setEditingGroup(null);
  };

  return (
    <div className="space-y-6">
      {/* En-tête */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-secondary-900">Groupes de contacts</h1>
          <p className="mt-1 text-sm text-secondary-500">
            Organisez vos contacts en groupes
          </p>
        </div>
        <button 
          className="btn btn-primary"
          onClick={() => setIsModalOpen(true)}
        >
          <Plus className="h-4 w-4 mr-2" />
          Nouveau groupe
        </button>
      </div>

      {/* Barre de recherche */}
      <div className="card">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-secondary-400" />
          <input
            type="text"
            placeholder="Rechercher un groupe..."
            className="input pl-10"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {/* Liste des groupes */}
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {filteredGroups.map((group) => (
          <div key={group.id} className="card hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h3 className="text-lg font-medium text-secondary-900">
                  {group.nom}
                </h3>
                <p className="mt-1 text-sm text-secondary-500">
                  {group.description}
                </p>
                <div className="mt-3 flex items-center text-sm text-secondary-500">
                  <Users className="h-4 w-4 mr-1" />
                  {group.contact_count} contact{group.contact_count > 1 ? 's' : ''}
                </div>
                <div className="mt-1 text-xs text-secondary-400">
                  Créé le {new Date(group.date_creation).toLocaleDateString('fr-FR')}
                </div>
              </div>
              <div className="flex space-x-1">
                <button
                  onClick={() => handleEdit(group)}
                  className="text-primary-600 hover:text-primary-900 p-1"
                  title="Modifier"
                >
                  <Edit className="h-4 w-4" />
                </button>
                <button
                  onClick={() => handleDelete(group.id)}
                  className="text-red-600 hover:text-red-900 p-1"
                  title="Supprimer"
                >
                  <Trash2 className="h-4 w-4" />
                </button>
              </div>
            </div>
            <div className="mt-4 flex space-x-2">
              <button className="btn btn-secondary flex-1 text-sm">
                <Eye className="h-4 w-4 mr-1" />
                Voir contacts
              </button>
              <button className="btn btn-primary flex-1 text-sm">
                <UserPlus className="h-4 w-4 mr-1" />
                Ajouter contacts
              </button>
            </div>
          </div>
        ))}
      </div>

      {filteredGroups.length === 0 && (
        <div className="text-center py-12">
          <Users className="mx-auto h-12 w-12 text-secondary-400" />
          <h3 className="mt-2 text-sm font-medium text-secondary-900">Aucun groupe</h3>
          <p className="mt-1 text-sm text-secondary-500">
            Commencez par créer votre premier groupe de contacts.
          </p>
          <div className="mt-6">
            <button 
              className="btn btn-primary"
              onClick={() => setIsModalOpen(true)}
            >
              <Plus className="h-4 w-4 mr-2" />
              Nouveau groupe
            </button>
          </div>
        </div>
      )}

      {/* Modal de groupe */}
      <GroupModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setEditingGroup(null);
        }}
        onSave={handleSaveGroup}
        group={editingGroup}
      />
    </div>
  );
};

export default Groups;
